import React from 'react';
import { Navigate, Link } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';

export default function AdminStubPage({ title, description, requireAdmin = true }) {
  const { user, loading } = useAuth();
  if (loading) return null;
  if (!user) return <Navigate to="/login" replace />;
  if (requireAdmin && user.role !== 'Admin') return <Navigate to="/" replace />;

  return (
    <div style={s.wrap}>
      <h1 style={s.h1}>{title}</h1>
      <p style={s.sub}>{description}</p>
      <div style={s.card}>
        <div style={s.empty}>🚧</div>
        <h2 style={s.h2}>Under construction</h2>
        <p style={s.muted}>This section is in development. Visible to admins only.</p>
        <Link to="/admin" style={s.link}>← Back to Admin Tools</Link>
      </div>
    </div>
  );
}

const s = {
  wrap:  { maxWidth: '1100px', margin: '0 auto', padding: '32px 24px', color: 'var(--text-primary)' },
  h1:    { fontSize: '28px', fontWeight: 700, margin: '0 0 4px' },
  sub:   { color: 'var(--text-secondary)', fontSize: '14px', margin: '0 0 24px' },
  card:  { background: 'var(--surface)', border: '1px solid var(--border)', borderRadius: '14px', padding: '40px 22px', textAlign: 'center', boxShadow: 'var(--shadow)' },
  empty: { fontSize: '40px', marginBottom: '12px' },
  h2:    { fontSize: '20px', fontWeight: 700, margin: '0 0 8px' },
  muted: { color: 'var(--text-secondary)', fontSize: '14px', margin: '0 0 16px' },
  link:  { color: 'var(--accent)', textDecoration: 'none', fontSize: '14px', fontWeight: 600 },
};
